import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./styles.less";

const Notes = ({ className, notesArr, isMobileView }) => {
  return (
    <div
      className={cx(styles.notes, className, {
        [styles.mobileView]: isMobileView
      })}
    >
      {notesArr.map((n, i) => <div key={i}>{`* ${n}`}</div>)}
    </div>
  );
};

Notes.propTypes = {
  className: PropTypes.string,
  isMobileView: PropTypes.bool,
  notesArr: PropTypes.array
};

export default Notes;



// WEBPACK FOOTER //
// ./src/components/Cart/Notes/Notes.js